import { storeMutation } from "@/store/storeMutations.constant";
import { storeAction } from "@/store/storeActions.constant";

const snackbarState = {
    visible: false,
    message: '',
    color: '',
  };

  const snackbarColorMap = {
    success: '#4CAF50',
    error: '#F44336',
    warning: '#FFC107',
  };

  const snackbarMutations = {
    [storeMutation.setSnackbar]: (state, { color, message }) => {
      state.visible = true;
      state.color = snackbarColorMap[color] || color;
      state.message = message;
    },
    [storeMutation.hideSnackbar]: (state) => {
      state.visible = false;
    },
  };

  const snackbarActions = {
    [storeAction.setToastMessage]: ({ commit }, payload) => {
      commit(storeMutation.setSnackbar, payload);
    },
    [storeAction.hideSnackbar]: ({ commit }) => {
      commit(storeMutation.hideSnackbar);
    },
  };

export default {
  namespaced: true,
  state: {
    initialState: snackbarState,
    ...snackbarState,
  },
  mutations: { ...snackbarMutations },
  actions: { ...snackbarActions },
  getters: { ...snackbarMutations },
};
